import { format } from "date-fns";

const shadowTailWind = "shadow-[0px_0px_4px_0px_#00000024]";

const ListAppointmentItem = (props) => {
  const { event, backgroundColor, textColor, onClick, itemTemplate } = props;
  const data = event.data;

  const isPast = event.date < new Date().setHours(0, 0, 0, 0);
  // const animate = !event.data.confirmation_bc_date ? true : false;
  // const stale = !event.data.confirmation_bc_date ? true : false;

  if (itemTemplate) {
    return itemTemplate({
      event,
      backgroundColor,
      textColor,
      onClick,
      itemTemplate,
    });
  } else
    return (
      <div
        // <motion.div
        className={`row-start-start ${
          isPast ? " bg-slate-100 " : shadowTailWind
        } w-full gap-2 cursor-pointer active:translate-y-0.5 active:bg-slate-50 !items-stretch `}
        // animate={
        //   animate
        //     ? {
        //         rotate: [0, -2, 2, 0],
        //         translateY: [0, -2, 0, 0],
        //       }
        //     : undefined
        // }
        // transition={
        //   animate
        //     ? {
        //         duration: 1,
        //         ease: "easeInOut",
        //         times: [0, 0.33, 0.677, 1],
        //         repeat: Infinity,
        //         repeatDelay: 0,
        //       }
        //     : undefined
        // }
        onClick={() => {
          if (onClick) onClick(event);
        }}
      >
        <div
          className={` w-[3px] ${isPast ? "bg-slate-300" : backgroundColor}`}
        />
        <div className={`col-center-start py-1 w-full gap-1`}>
          {data.data_employee && <span> {data.data_employee.name} </span>}

          <span className="italic text-sm text-slate-400 font-semibold">
            {data.date
              ? format(
                  new Date(data.date),
                  "dd/MM/yyyy"
                )
              : "-"}
          </span>
          {data.description && (
            <div className={`col-start-start text-sm`}>
              {`${data.description}`}
            </div>
          )}
        </div>
        {/* </motion.div> */}
      </div>
    );
};

export default ListAppointmentItem;
